import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Router } from '@angular/router'

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  providers: [AngularFireDatabase]
})
export class NotificationItemComponent implements OnInit {

  @Input() reply;
  sender : any = {
    avatarUrl: 'https://chispa-rural.firebaseapp.com/assets/img/avatar.png',
  }

  constructor(private db : AngularFireDatabase, private router : Router) { }

  ngOnInit() {
   this.db.object('profiles/' + this.reply.senderId)
      .snapshotChanges()
      .subscribe(user => {
        this.sender.key = user.key;
        Object.assign(this.sender, user.payload.val());
      });
  }

  navigateToActivity() {
    if (this.reply.status === 'unread') this.db.object('/activity/'+ this.reply.key).update({status: 'read'});

    switch (this.reply.action) {
      case 'FORUM_REPLY':
        this.router.navigate(['/discusion',this.reply.objectId]);
        break;
      case 'NEW_MESSAGE':
        this.router.navigate(['/perfil/mensajes',this.reply.objectId]);
        break;
    }
  }

  getMessage() {
    switch (this.reply.action) {
      case 'FORUM_REPLY':
        return `respondió a tu <a [routerLink]="['/discusion/', ${this.reply.objectId}]">publicación</a>`;
      case 'NEW_MESSAGE':
        return `te envió un <a [routerLink]="['/perfil/mensajes', ${this.reply.objectId}]">mensaje</a>`;
    }
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/activity/notification-item/notification-item.component.ts